/**
 * Field validation for schema-driven lead forms. Returns an error string per
 * invalid field; an empty object means the step/form is valid.
 */

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function phoneDigitCount(value) {
  return String(value || "").replace(/\D/g, "").length;
}

export function isEmpty(value) {
  if (value === undefined || value === null) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "number") return Number.isNaN(value);
  return false;
}

export function isVisible(field, values, context) {
  return typeof field.showIf === "function" ? Boolean(field.showIf(values, context)) : true;
}

export function validateField(field, value, values, context) {
  if (field.type === "hidden") return null;
  if (isEmpty(value)) {
    return field.required ? field.requiredMessage || `Please enter ${field.errorName || "this"}` : null;
  }
  if (field.type === "email" && !EMAIL_RE.test(String(value).trim())) {
    return "Please enter a valid email address";
  }
  if (field.type === "tel") {
    const digits = phoneDigitCount(value);
    if (digits < 7 || digits > 15) return "Please enter a valid phone number";
  }
  if (field.type === "number" || field.type === "currency") {
    const num = Number(String(value).replace(/[£,\s]/g, ""));
    if (Number.isNaN(num)) return "Please enter a number";
    if (field.min !== undefined && num < field.min) return `Must be at least ${field.min}`;
    if (field.max !== undefined && num > field.max) return `Must be no more than ${field.max}`;
  }
  if (field.maxLength && String(value).length > field.maxLength) {
    return `Please keep this under ${field.maxLength} characters`;
  }
  if (typeof field.validate === "function") {
    return field.validate(value, values, context) || null;
  }
  return null;
}

/** Validate every visible field in `fields` (flattened). */
export function validateFields(fields, values, context) {
  const errors = {};
  fields.forEach((field) => {
    if (!isVisible(field, values, context)) return;
    const error = validateField(field, values[field.name], values, context);
    if (error) errors[field.name] = error;
  });
  return errors;
}
